import gql from 'graphql-tag';

export const GET_AWS_PROFILES = gql`
  query {
    awsProfiles {
      id
      name
      roleArn
      ecsClusters {
        id
        name
      }
    }
  }
`;

export const GET_AWS_PROFILE = gql`
  query($id: ID!) {
    awsProfile(id: $id) {
      id
      name
      roleArn
      ecsClusters {
        id
        name
        region
      }
    }
  }
`;

export const CREATE_AWS_PROFILE = gql`
  mutation($profile: CreateAwsProfileInput!) {
    createAwsProfile(input: $profile) {
      id
      name
      roleArn
    }
  }
`;

export const UPDATE_AWS_PROFILE = gql`
  mutation($id: ID!, $profile: UpdateAwsProfileInput!) {
    updateAwsProfile(id: $id, input: $profile) {
      id
      name
      roleArn
    }
  }
`;

export const DELETE_AWS_PROFILE = gql`
  mutation($id: ID!) {
    deleteAwsProfile(id: $id)
  }
`;

export const IMPORT_ECS_CLUSTERS = gql`
  mutation($id: ID!) {
    importEcsClusters(profileId: $id) {
      id
      name
      region

      awsProfile {
        id
        name
        roleArn
      }
    }
  }
`;

export const DELETE_ECS_CLUSTER = gql`
  mutation($id: ID!) {
    deleteEcsCluster(id: $id)
  }
`;

export const ARCHIVE_USER = gql`
  mutation($id: ID!) {
    archiveUser(id: $id) {
      id
    }
  }
`;

export const GET_NEW_RELIC_ACCOUNTS = gql`
  query {
    newRelicAccounts {
      id
      accountId
      name
      apiKey
      insightsKey
      v2Keys
    }
  }
`;

export const CREATE_NEW_RELIC_ACCOUNT = gql`
  mutation($configuration: CreateNewRelicAccountInput!) {
    createNewRelicAccount(input: $configuration) {
      id
    }
  }
`;

export const DELETE_NEW_RELIC_ACCOUNT = gql`
  mutation($id: ID!) {
    deleteNewRelicAccount(id: $id)
  }
`;

export const UPDATE_NEW_RELIC_ACCOUNT = gql`
  mutation($id: ID!, $configuration: UpdateNewRelicAccountInput!) {
    updateNewRelicAccount(id: $id, input: $configuration) {
      id
    }
  }
`;

export const GET_NEW_RELIC_ACCOUNT = gql`
  query($id: ID!) {
    newRelicAccount(id: $id) {
      id
      name
      accountId
      apiKey
      insightsKey
      v2Keys
    }
  }
`;

export const GET_FEATURES = gql`
  query {
    tenantFeatures {
      key
      value
    }
  }
`;
